import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyTrustedContact = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 116,
	height: 116,
	viewBox: "0 0 116 116",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		opacity: .64,
		clipPath: "url(#clip0_3193_31533)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M84.6556 77.1883C80.1606 76.3183 76.7289 72.4033 76.7289 67.6667C76.7289 66.99 76.8256 66.265 76.9706 65.6367C71.8473 60.9 64.9839 58 57.3956 58C49.8073 58 42.9439 60.9 37.8206 65.6367C37.9656 66.265 38.0623 66.99 38.0623 67.6667C38.0623 72.4033 34.6306 76.3183 30.1356 77.1883C30.0873 77.285 30.0389 77.3333 30.0389 77.43C39.9473 78.2517 47.7289 86.5167 47.7289 96.6667H67.0623C67.0623 86.5167 74.8439 78.2517 84.7523 77.43C84.7523 77.3333 84.7039 77.285 84.6556 77.1883Z",
				fill: "#7DA0E2"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M57.3964 58C65.4045 58 71.8964 51.5081 71.8964 43.5C71.8964 35.4919 65.4045 29 57.3964 29C49.3882 29 42.8964 35.4919 42.8964 43.5C42.8964 51.5081 49.3882 58 57.3964 58Z",
				fill: "#7DA0E2"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M86.3958 77.3322C75.7142 77.3322 67.0625 85.9838 67.0625 96.6655C67.1108 96.6655 105.729 96.6655 105.729 96.6655C105.729 85.9838 97.0775 77.3322 86.3958 77.3322Z",
				fill: "#FFBF5F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M86.397 77.3333C91.7358 77.3333 96.0637 73.0054 96.0637 67.6667C96.0637 62.3279 91.7358 58 86.397 58C81.0583 58 76.7303 62.3279 76.7303 67.6667C76.7303 73.0054 81.0583 77.3333 86.397 77.3333Z",
				fill: "#FFBF5F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M28.3958 77.3322C17.7142 77.3322 9.0625 85.9838 9.0625 96.6655C9.11083 96.6655 47.7292 96.6655 47.7292 96.6655C47.7292 85.9838 39.0775 77.3322 28.3958 77.3322Z",
				fill: "#FFBF5F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M28.397 77.3333C33.7358 77.3333 38.0637 73.0054 38.0637 67.6667C38.0637 62.3279 33.7358 58 28.397 58C23.0583 58 18.7303 62.3279 18.7303 67.6667C18.7303 73.0054 23.0583 77.3333 28.397 77.3333Z",
				fill: "#FFBF5F"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M11.1815 58.6954C7.47323 57.6322 3.59078 57.0958 -0.175445 56.6044C-0.986631 56.5014 -1.73976 57.0762 -1.7977 57.8861C-1.91359 58.6966 -1.33383 59.4378 -0.580585 59.5409C3.06975 60.0139 6.83564 60.5201 10.3701 61.5437C11.1233 61.7657 11.9349 61.3087 12.1666 60.5224C12.3984 59.7368 11.9348 58.918 11.1815 58.6954Z",
				fill: "#A2E3FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M22.4218 43.6206C16.4537 37.3978 9.73248 31.976 3.88035 25.5862C3.35887 24.9895 2.4318 24.9575 1.85238 25.5146C1.27296 26.0723 1.21525 27.01 1.79467 27.6068C7.6468 34.0149 14.3681 39.4545 20.3361 45.6957C20.9155 46.2782 21.8423 46.2865 22.4218 45.7134C22.9432 45.1409 23.0012 44.2032 22.4218 43.6206Z",
				fill: "#A2E3FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M33.6053 19.6854C33.7792 23.2471 33.9526 26.8087 34.1265 30.371C34.1265 31.1868 34.8221 31.8167 35.6333 31.7771C36.4445 31.7368 37.0236 31.0423 37.0236 30.2259C36.8497 26.6584 36.6762 23.0914 36.5024 19.5244C36.4445 18.7086 35.7491 18.0828 34.9379 18.1272C34.1846 18.1716 33.5474 18.8702 33.6053 19.6854Z",
				fill: "#A2E3FF"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3193_31533",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 116,
			height: 116,
			fill: "white"
		})
	}) })]
});
export default SvgEmptyTrustedContact;
